module.exports = __webpack_public_path__ + "img/horizontal_7_6_pp1_2.5a62dac8.png";